module.exports = __webpack_public_path__ + "static/img/confirm_img.dabbbf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/confirm_img.png
// module id = 4Dgf
// module chunks = 102